import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { XpoConfirmDialog, XpoConfirmDialogConfig } from '@xpo-ltl/ngx-ltl-core/confirm-dialog';
import { Observable } from 'rxjs';

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

@Injectable()
export class PendingChangesGuard implements CanDeactivate<ComponentCanDeactivate> {
  constructor(private confirmDialog: XpoConfirmDialog) {}

  canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> {
    return component.canDeactivate() ? true : this.openConfirmDialog();
  }

  private openConfirmDialog(): Observable<boolean> {
    const leaveConfirmConfig: XpoConfirmDialogConfig = {
      confirmButtonText: 'Yes',
      rejectButtonText: 'No',
      showCancelButton: true,
      icon: 'warning',
    };

    return this.confirmDialog.confirm(
      'Unsaved changes will be lost',
      'Are you sure you want to leave this page?',
      leaveConfirmConfig
    );
  }
}
